import React, { Component } from 'react';
import { Translation } from 'react-i18next';
import FooterComponent from './common/FooterComponent';

const langs = {
  'vi': <img src={require('../assets/imgs/image-vi.png')} alt="guide" />,
  'en': <img src={require('../assets/imgs/image-en.png')} alt="guide" />,
}

class GuideComponent extends Component {
  render() {
    const language = window.localStorage.getItem('LANG') ?? 'vi';

    return (
      <Translation>
        {(t) => (
          <div className="guide-wrap">
            <div className="pt-small guide-foreground">
              {langs[language]}
              <div className="d-flex justify-center pt-small">
                <a className="btn-guide" href="http://bit.ly/Trustkeys_huongdansudung" rel="noreferrer" target="_blank">
                  <div className="uppercase text-normal text-white">
                    {t('tutorial_watch_more')}
                  </div>
                </a>
                <div className="btn-guide-blur" />
              </div>
            </div>
            <div className="footer">
              <FooterComponent />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default GuideComponent;
